module.exports = __webpack_public_path__ + "static/media/TRIAL 2-unansweredafter-10-sec.111b4110.mp3";